import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Valida um CPF pelos dígitos verificadores.
 * Campo vazio é considerado válido — quem cobra o preenchimento é o Validators.required.
 */
export function cpfValidator(control: AbstractControl<string>): ValidationErrors | null {
  const digits = onlyDigits(control.value);

  if (!digits) {
    return null;
  }

  if (digits.length !== 11 || isRepeatedSequence(digits)) {
    return { cpf: true };
  }

  const isValid =
    checkDigit(digits, 9) === Number(digits[9]) &&
    checkDigit(digits, 10) === Number(digits[10]);

  return isValid ? null : { cpf: true };
}

function onlyDigits(value: string | null | undefined): string {
  return (value ?? '').replace(/\D/g, '');
}

/** Remove a máscara e completa com zeros à esquerda até 11 dígitos, para envio no payload da API. */
export function sanitizarCpfParaPayload(cpf: string): string {
  return onlyDigits(cpf).padStart(11, '0');
}

function isRepeatedSequence(digits: string): boolean {
  return /^(\d)\1{10}$/.test(digits);
}

/** Calcula o dígito verificador a partir dos `length` primeiros dígitos. */
function checkDigit(digits: string, length: number): number {
  let sum = 0;

  for (let index = 0; index < length; index++) {
    sum += Number(digits[index]) * (length + 1 - index);
  }

  const remainder = (sum * 10) % 11;
  return remainder === 10 ? 0 : remainder;
}
